import React, {useEffect, useState}from 'react';
import {Modal} from 'antd-mobile';
import { unionFlag, getSessonStorage } from '@/utils';
import withRouter from 'umi/withRouter';
import { connect } from 'dva';
import {router} from 'umi';
import NavBar from '@/components/NavBar';
import Icon from '@/components/Icon';
import Notice from '@/components/Notice';
import api from '@/common/api';
import styles from './index.less';

import pz from '../../assets/imgs/location.png';
import call from '../../assets/imgs/Call_B.png';
import nocinemapic from '../../assets/imgs/cinema.png';

import { BFD_checkApp } from '@/utils/bfdApp';
import { checkXcx } from '@/utils/checkXcx';
import { TLang } from '@/utils/lang';
import DfIcon from '@df-mobile/df-icon';


const CinemaDetail = (props) => {
  // 电影详情数据
  const [cinamaData, setCinemaData]=useState<any>();
  // 获取电影详情
  useEffect(() => {
    // 获取 id .请求数据
    const id = props.history.location.query?.id;
    // request movie data
    id && api.getCinema(id).then((res) => {
      if(res){
        setCinemaData(res);
      }
    });
  }, []);
  const gotLocationMap = () => {
    if(cinamaData.latitude && cinamaData.longitude){
      router.push({
        pathname: '/map',
        query: {
          name: cinamaData.name,
          addr: cinamaData.zhAddress,
          latitude: cinamaData.latitude,
          longitude: cinamaData.longitude
        }
      });
    }

  };
  const [showTelModal, setShowTelModal] = useState(false);
  const isApp = BFD_checkApp();
  // const isXcx = checkXcx();
  const union = unionFlag() || getSessonStorage('dffl_union');
  // TODO: 根据浙商union判断是否展示，浙商小程序添加汉堡包按钮
  const isXcx = checkXcx() && union !== 'ejyshop';
  return <div className={`${styles.cinemaDetail} cinemaDetail`}>
    {
      cinamaData?<>
        {
          (isApp=== false && !isXcx)? <NavBar initColor="#FFF" targetColor="#333" targetBgColor="#FFF" opacity={0}/>: null
        }
        {
          cinamaData.notice ? <div className={styles.noticeWrapper}>
            <Notice bgColor="rgba(0,0,0,0.4)" textColor="#FFFFFF" text={cinamaData.notice}/>
          </div>:null
        }
        <div>
          {
            cinamaData.logo? <img src={cinamaData.image || cinamaData.logo} className={styles.logo} />:<img src={nocinemapic} className={styles.logo} alt="logo" />
          }
          <div className={styles.mask}/>
          <div className={styles.container}>
            <div className={styles.section}>
              <div className={styles.sctionHeader}>{cinamaData.name}</div>
              <div className={styles.sectionContent} onClick={gotLocationMap}>
                <span className={styles.position}>
                  <DfIcon type={'IconFont'} iconUrl="icon-dingwei" iconColor={window?.dffl_global?.allCommonTheme?.globalThemeColor} />
                </span>
                <span>{cinamaData?.address}</span>
                <div className={styles.arrow}>
                  <Icon key="1"
                    type="order_selectdate_more"
                    size="sm"
                    style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', color:'#999'}}
                  />
                </div>
              </div>
              <div className={`${styles.sectionContent} ${styles.sc2}`} onClick={() => setShowTelModal(true)} >
                {/* <img className={styles.position} src={call} alt=""/> */}
                <span className={styles.position}>
                  <DfIcon type={'IconFont'} iconUrl="icon-dianhua" iconColor={window?.dffl_global?.allCommonTheme?.globalThemeColor} />
                </span>
                <span>{cinamaData.telephone}</span>
                <div className={styles.arrow}>
                  <Icon key="2"
                    type="order_selectdate_more"
                    size="sm"
                    style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', color:'#999'}}
                  />
                </div>
              </div>
            </div>
            {
              cinamaData.features&&cinamaData.features.length>0?
                <div className={styles.section}>
                  <div className={styles.sctionHeader}>{TLang('影院服务', 'home', false, false, null)}</div>
                  {
                    cinamaData.features && cinamaData.features.map((item, i) => <div className={styles.sc3} key={i}>
                      <div className={styles.name}><span>{item.name}</span></div>
                      <div className={styles.desc}><span>{item.desc}</span></div>
                    </div>)
                  }
                </div>:null
            }
            {
              cinamaData.busAddress?
                <div className={styles.section}>
                  <div className={styles.sctionHeader}>{TLang('交通信息', 'home', false, false, null)}</div>
                  {
                    cinamaData.busAddress?<p className={styles.sc4}>{cinamaData.busAddress}</p>:null
                  }
                  {
                    cinamaData.metroAddress?<p className={styles.sc4}>{cinamaData.metroAddress}</p>:null
                  }
                  {
                    cinamaData.driveAddress?<p className={styles.sc4}>{cinamaData.driveAddress}</p>:null
                  }
                </div>:null
            }
            {
              cinamaData.info?
                <div className={styles.section}>
                  <div className={styles.sctionHeader}>{TLang('影院介绍', 'home', false, false, null)}</div>
                  <p className={styles.sc5}>{cinamaData.info}</p>
                </div>:null
            }
          </div>
        </div>
        <Modal
          popup
          visible={showTelModal}
          onClose={() => setShowTelModal(false)}
          animationType="slide-up"
          className="telDesc"
        >
          <div className="telModalWrapper">
            <a className="tel" href={`tel:${cinamaData.telephone}`}>{cinamaData.telephone||''}</a>
            <div className="cancel" onClick={() => setShowTelModal(false)}>{TLang('取消', 'home', false, false, null)}</div>
          </div>
        </Modal>
      </>:null
    }
  </div>;
};

export default withRouter(connect()(CinemaDetail));
